var map = {
	"./address_image.svg": 147,
	"./animated_logo.svg": 148,
	"./autocert.png": 149,
	"./autoicon.png": 150,
	"./blogs_image.svg": 151,
	"./celeb.png": 152,
	"./cloud_infrastructure.svg": 153,
	"./codeInLogo.png": 154,
	"./contactMail.png": 155,
	"./coursera.png": 156,
	"./coursera_logo.png": 157,
	"./data_science.svg": 158,
	"./deeplearning_ai_logo.png": 159,
	"./delhivery_logo.png": 160,
	"./developerActivity.svg": 161,
	"./dsc_logo.png": 162,
	"./education.svg": 163,
	"./eduskills.jpg": 164,
	"./experience.svg": 165,
	"./feelingProud.svg": 166,
	"./freecopy_logo.png": 167,
	"./fullstack.svg": 168,
	"./gcp_logo.png": 169,
	"./github_logo.png": 170,
	"./googleAssistant.jpg": 171,
	"./googleAssistant.svg": 172,
	"./google_logo.png": 173,
	"./ibm_logo.png": 174,
	"./iiitk_logo.png": 175,
	"./image.png": 176,
	"./intel_logo.jpg": 177,
	"./iu_logo.png": 178,
	"./jpmorganchase_logo.jpg": 179,
	"./jsFramework.svg": 180,
	"./legato_logo.png": 181,
	"./manOnTable.svg": 182,
	"./microsoft_logo.png": 183,
	"./mozilla_logo.png": 184,
	"./muffito_logo.png": 185,
	"./newimg.png": 186,
	"./nextuLogo.jpg": 187,
	"./nobg.png": 188,
	"./nptel.png": 189,
	"./nptel_logo.png": 190,
	"./oracle.png": 191,
	"./portfolio.gif": 192,
	"./postcert.png": 193,
	"./postman.png": 194,
	"./programmer.svg": 195,
	"./projects_image.svg": 196,
	"./pwa.png": 197,
	"./redhatexs.png": 198,
	"./saayaHealthLogo.png": 199,
	"./salesforceb.png": 200,
	"./ssa.png": 201,
	"./stanford_logo.png": 202,
	"./talksCardBack.svg": 203,
	"./talksCardBackAlt.svg": 204,
	"./tiktok_logo.png": 205,
	"./ui_ux_design.svg": 206
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37;